import { useEffect } from "react";
import { useChain } from "./useChain";
import { useSelector, useDispatch } from "react-redux";
import { updateStakeData } from "store";

import { useWithdraw } from "@stader-labs/web-sdk"; // from "@stader-labs/web-sdk"

export const useWithdrawals = () => {
  const dispatch = useDispatch();
  const { fetchWithdrawals } = useWithdraw();

  const { walletAddress, config, walletAddressHedera } = useSelector(
    (state: any) => state.wallet
  );
  const { isStaking, isUnstaking, tokenAmount, tokenXAmount } = useSelector(
    (state: any) => state.user
  );
  const { txn } = useSelector((state: any) => state.user);

  const { status } = useChain();

  const fetchClaimData = async () => {
    let claimData = [];

    const address = walletAddressHedera ?? walletAddress;

    if (address) {
      // ? This method returns a string when there are no withdrawals :facepalm:
      claimData = await fetchWithdrawals(address).catch((e) => {
        console.error("Failed to withdraw", e);
      });
    }
    // ? update only if claimData is an array and not an error string
    if (Array.isArray(claimData)) {
      dispatch(
        updateStakeData({
          withdrawals: claimData,
        })
      );
    }
  };

  useEffect(() => {
    fetchClaimData();
    setTimeout(() => {
      fetchClaimData();
    }, 4000);
  }, [
    walletAddress,
    txn.status,
    isStaking,
    isUnstaking,
    status,
    config,
    tokenAmount,
    tokenXAmount,
    walletAddressHedera,
  ]);

  return null;
};
